import gql from 'graphql-tag';

export const GET_COURSE_LIST = gql`
  query(
    $golf_group_code: String
    $golf_code: String
    $limit_rows: Int
    $begin_row: Int
  ){
    GetCourseListByPlanMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        limit_rows: $limit_rows
        begin_row: $begin_row
  ){
    CourseList{
      golf_code
      golf_group_code
      course_code
      course_name
      valid_flag
    }
    count
  }
}
`;

export const UPDATE_COURSE = gql`
  mutation(
    $golf_code: String
    $golf_group_code: String
    $course_name: String
    $valid_flag: Int
    $course_code: String
  ){
    UpdateCourse(
    golf_code: $golf_code
    golf_group_code: $golf_group_code
    course_name: $course_name
    valid_flag: $valid_flag
    course_code: $course_code
  ){
    result
  }
}
`;

export const REGISTER_COURSE = gql`
  mutation(
    $golf_code: String
    $golf_group_code: String
    $course_name: String
    $valid_flag: Int
  ){
    RegisterCourse(
        golf_code: $golf_code
        golf_group_code: $golf_group_code
        course_name: $course_name
        valid_flag: $valid_flag
  ){
    result
  }
}
`;
